import { send } from '../../../../../../src/network/network';
import { type ResetSurvey } from '../../../../../../src/types/ResetSurvey';

export type ResetSurveyParams = {
  customerId: number;
};
export async function postApiV2CustomersCustomerIdResetSurvey({
  customerId,
}: ResetSurveyParams) {
  return await send<ResetSurvey>({
    // currently this endpoint does not support "self" https://hungryroot.atlassian.net/browse/BE-6110
    path: `/api/v2/customers/${customerId}/reset_survey/`,
    method: 'POST',
  });
}
